module.exports = __webpack_public_path__ + "static/media/cat_fall.a31b6c8d.jpg";